import React from 'react';
import serviceImage1 from '../../assets/images/pick_story_type_img.png';
import serviceImage2 from '../../assets/images/image_story_view_2.png';
import serviceImage3 from '../../assets/images/colloborate_feature.png';
import DownloadBlock from '../shared/DownloadBlock';

function Service() {
  return (
    <>
      <section className="row_am service_section">
        <div className="anchor" id="services" />
        <div className="container">
          <div className="section_title" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
            <span className="title_badge mb-1">Artificial Intelligence</span>
            <h2>
              <span>AI</span> Powered Stories
            </h2>
          </div>
          <div className="row service_blocks">
            <div className="col-md-6">
              <div className="service_text" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                <h2>
                  Discover Our <span>Story Types</span>
                </h2>
                <p>
                  We use cutting-edge AI models to generate unique stories in three formats, offering an engaging reading experience for users of all ages.
                </p>
                <ul className="listing_block">
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-ui-check" />
                      </span>
                    </div>
                    <div className="text">
                      <h3>Text Stories</h3>
                      <p>Enjoy wonderful and well-crafted text stories that bring your idea to life through words.</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-ui-check" />
                      </span>
                    </div>
                    <div className="text">
                      <h3>Stories with Images</h3>
                      <p>Enjoy image stories that combine engaging text with stunning AI-generated images, making each page a visual delight.</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-ui-check" />
                      </span>
                    </div>
                    <div className="text">
                      <h3>Stories with Video</h3>
                      <p>Engage with dynamic video stories that merge text, sound, and motion.</p>
                    </div>
                  </li>
                </ul>

                <DownloadBlock />
              </div>
            </div>
            <div className="col-md-6">
              <div className="img centered_img" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                <img src={serviceImage1} alt="image" />
              </div>
            </div>
          </div>
          <div className="row service_blocks flex-row-reverse">
            <div className="col-md-6">
              <div className="service_text right_side" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                <h2>
                  Unique Customizable <span>Voice Over</span>
                </h2>
                <p>
                The app provides AI-generated voice-overs for each story, allowing you to play the story with audio narration. FairyTaler offers multiple voice types to make each story truly unique. Additionally, you can override the auto-generated voice-over with your own recording, so your child can hear their parents telling them the story.
                </p>
                <ul className="feature_list">
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-check-circled" />
                      </span>
                    </div>
                    <div className="text">
                      <p>AI-Generated Voice Overs</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-check-circled" />
                      </span>
                    </div>
                    <div className="text">
                      <p>Multiple Voice Types</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-check-circled" />
                      </span>
                    </div>
                    <div className="text">
                      <p>Custom Recordings</p>
                    </div>
                  </li>
                </ul>
                <DownloadBlock />
              </div>
            </div>
            <div className="col-md-6">
              <div className="img centered_img" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                <img src={serviceImage2} alt="image" />
              </div>
            </div>
          </div>
          {/* <div className="row service_blocks">
            <div className="col-md-6">
              <div className="service_text" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                <h2>
                  Narrate, <span>Collaborate</span>, Elevate, Share
                </h2>
                <p>
                  At FairyTaler, storytelling is a team sport. Connect with friends, family, and dreamers. Collaborate
                  on characters, plot twists, and storylines to create unforgettable tales together.
                </p>
                <ul className="feature_list">
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-check-circled" />
                      </span>
                    </div>
                    <div className="text">
                      <p>Collaborative Storytelling</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-check-circled" />
                      </span>
                    </div>
                    <div className="text">
                      <p>Easy Sharing</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-check-circled" />
                      </span>
                    </div>
                    <div className="text">
                      <p>Elevate Your Stories</p>
                    </div>
                  </li>
                </ul>
                <DownloadBlock />
              </div>
            </div>
            <div className="col-md-6">
              <div className="img centered_img" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                <img src={serviceImage3} alt="image" />
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
}

export default Service;
